import React from 'react'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Card from 'react-bootstrap/Card'

export default function Workswith({ product }) {
    const { works_with } = product
    if (!works_with.length) return
    return (
        <>
            <h6 className='fw-medium text-uppercase mt-md-5 mt-3 mb-4' style={{ fontSize: 18 }}>
                Works With:
            </h6>
            {/* WORKSWITH CONTAINER */}
            <div className='position-relative'>
                {/* MACOS, WINDOWS, GARAGEBAND, MPC DESKTOP SOFTWARE */}
                <Row xs='auto' xl={5} className='flex-nowrap overflow-auto'>
                    {
                        works_with.map((_, i) => {
                            const { name, path } = _
                            return (
                                <Col key={name + path + i}>
                                    <Card className='h-100 bg-transparent border-0 text-center'>
                                        <Card.Header className='p-0 border-0 bg-transparent mb-2'>
                                            <img src={path} alt='' height={40} />
                                        </Card.Header>
                                        <Card.Footer className='p-0 border-0 bg-transparent'>
                                            <p className='m-0'>{name}</p>
                                        </Card.Footer>
                                    </Card>
                                </Col>
                            )
                        })
                    }
                </Row>
                {/* CHEVRON RIGHT BLACK */}
                {/* {works_with.length > 4 && <img
                    src={chevronrightblack} alt=''
                    className='position-absolute'
                    style={{ right: -8, top: '50%', transform: 'translateY(-50%)' }}
                />} */}
            </div>
        </>
    )
}